module.exports = __webpack_public_path__ + "img/headRight5Logo.93eedc00.png";